import script from "./FormDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDropdown.vue?vue&type=script&setup=true&lang=js"

import "./FormDropdown.vue?vue&type=style&index=0&id=bd367c7c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd367c7c"]])

export default __exports__